import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/do-not-sell")({
  beforeLoad: () => {
    throw redirect({ to: "/choices", replace: true, statusCode: 301 });
  },
});
